import { render, staticRenderFns } from "./WhiteTags.vue?vue&type=template&id=cb308ca6&"
import script from "./WhiteTags.vue?vue&type=script&lang=js&"
export * from "./WhiteTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports